export const MAX_WISHLIST_ITEMS = 99;
export const MAX_WISHLISTS = 20;
